/** Define maximum symbols for a password */
export const passwordMaxLength = 40;
/** Define exact number of digits for a two-factor authentication code */
export const twofaCodeExactLength = 6;
/** Define exact number of symbols for a two-factor authentication recovery code */
export const twofaRecoveryCodeExactLength = 17;
